<script setup lang="ts">
import LoadingBar from '@/components/Skeletons/LoadingBar.vue';
import Skeleton from 'primevue/skeleton';
// import { ref } from 'vue';

// Mock skeleton data
// const skeletonCategories = ref([
//   { name: 'Category 1', dishes: ['Dish 1', 'Dish 2', 'Dish 3'] },
//   { name: 'Category 2', dishes: ['Dish 4', 'Dish 5'] },
//   { name: 'Category 3', dishes: ['Dish 6', 'Dish 7', 'Dish 8', 'Dish 9'] },
// ]);
</script>

<template>
  <div>
    <!-- Header skeleton -->
    <LoadingBar :duration-in-seconds="30" class="mb-6" />

    <div class="mb-7 flex items-center justify-between gap-2">
      <Skeleton height="2rem" width="200px" class="bg-primary-300 dark:bg-primary-500" />
      <!-- <Skeleton height="32px" width="32px" border-radius="50%" class="bg-primary-300 dark:bg-primary-500" /> -->
    </div>

    <!-- Loading Bar -->

    <!-- Menu Name Input Skeleton -->
    <div class="mb-4 flex items-center gap-4">
      <Skeleton height="1.5rem" width="150px" class="bg-primary-300 dark:bg-primary-500" />
      <!-- <Skeleton height="40px" width="200px" class="bg-primary-300 dark:bg-primary-500" /> -->
    </div>

    <!-- Categories Skeleton -->
    <div class="mt-4 flex flex-col gap-6">
      <Skeleton height="3.5rem" class="bg-primary-300 dark:bg-primary-500" />
      <Skeleton height="3.5rem" class="bg-primary-300 dark:bg-primary-500" />
      <Skeleton height="3.5rem" class="bg-primary-300 dark:bg-primary-500" />

      <!-- Add Category Button Skeleton -->
      <!-- <div class="mt-4">
        <Skeleton height="40px" width="150px" class="bg-primary-300 dark:bg-primary-500" />
      </div> -->
    </div>

    <!-- Action Buttons Skeleton -->
    <!-- <div class="mt-6 flex gap-2">
      <Skeleton height="40px" width="100px" class="bg-primary-300 dark:bg-primary-500" />
      <Skeleton height="40px" width="100px" class="bg-primary-300 dark:bg-primary-500" />
    </div> -->
  </div>
</template>
